module.exports = __webpack_public_path__ + "img/рз_40.ddf05fb9.png";